import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Dialog, Toast, Typography } from '@chilecompra/react-kit/components'
import { SUSTAINABLE_PURCHASES_FILE } from '../../config/settings/constants'

import { onCloseMoreInfoDialog } from './QuoteStepTwo.actions'
import {
  Container,
  DialogButtons,
  DialogContent,
  DialogMessage,
  DownloadIcon,
  DownloadLink,
  Tab,
  Tabs
} from './QuoteStepTwo.styles'

/**
 * The QuoteStepTwo's more info dialog.
 */
const QuoteStepTwoMoreInfoDialog = () => {
  const dispatch = useDispatch()

  const { showMoreInfoDialog } = useSelector(state => state.quoteStepTwo)

  const handleCloseMoreInfoDialog = () => dispatch(onCloseMoreInfoDialog())

  return (
    <Dialog
      disableBackdropClick
      disableCloseIcon
      margin="auto"
      maxWidth="700px"
      onClose={handleCloseMoreInfoDialog}
      open={showMoreInfoDialog}
      padding="16px"
    >
      <DialogContent padding="16px">
        <DialogMessage margin="0 0 8px">
          <Typography fontWeight="bold" margin="0 0 16px" variant="h4">
            ¿Qué es una compra pública sustentable?
          </Typography>

          <Typography margin="0 0 16px" variant="body2">
            Es aquella que equilibra aspectos sociales, económicos y ambientales para generar mayor valor en todo el
            ciclo de vida del bien o servicio, reduciendo el impacto ecológico y generando beneficios sociales.
          </Typography>

          <Toast margin="0 0 24px" severity="info">
            La sustentabilidad se puede incorporar como requisito obligatorio o criterio de evaluación, según el
            análisis del caso, procurando no limitar injustamente la participación de proveedores.
          </Toast>

          <Container flexDirection="column">
            <Tabs padding="24px 0" value="environmental" variant="fullWidth">
              <Tab id="environmental" label="Medioambientales">
                <Typography fontWeight="bold" margin="0 0 16px" variant="h4">
                  ¿Qué son los criterios de evaluación o requisitos medioambientales?
                </Typography>

                <Typography margin="0 0 16px" variant="body2">
                  Buscan reducir el impacto ambiental de las compras públicas, considerando eficiencia energética,
                  materiales sustentables, vida útil y disposición final del producto o servicio.
                </Typography>

                <Typography margin="0 0 16px" variant="body2">
                  Ejemplos: reciclaje de desechos (papel, vidrio, electrónicos), eficiencia energética (LED, A+, Energy
                  Star), reducción de emisiones contaminantes, uso de materiales certificados (FSC, PEFC, reciclados) y
                  menaje reutilizable en catering.
                </Typography>

                <Typography margin="0 0 16px" variant="body2">
                  Se validan mediante sellos, certificaciones (Energy Star, HuellaChile, FSC, etc.), fichas técnicas,
                  declaraciones juradas o sitios oficiales.
                </Typography>
              </Tab>

              <Tab id="social-economic" label="Sociales o económicos">
                <Typography fontWeight="bold" margin="0 0 16px" variant="h4">
                  ¿Qué son los criterios de evaluación o requisitos sociales o económicos?
                </Typography>

                <Typography margin="0 0 16px" variant="body2">
                  Promueven el desarrollo local, el empleo digno y la equidad en las compras públicas.
                </Typography>

                <Typography margin="0 0 16px" variant="body2">
                  Ejemplos: buenas condiciones laborales, inclusión de personas con discapacidad o jóvenes, equidad de
                  género (Sello Empresa Mujer), apoyo a pymes y cooperativas (Sello ProPyme), y fomento al mercado
                  local.
                </Typography>

                <Typography margin="0 0 16px" variant="body2">
                  Se validan mediante certificaciones, sellos (Empresa Mujer, ProPyme, APL, etc.), declaraciones, fichas
                  técnicas o contratos laborales.
                </Typography>
              </Tab>
            </Tabs>
          </Container>
        </DialogMessage>

        <DialogButtons alignItems="center" justifyContent="space-between">
          <DownloadLink
            download="instructivo-de-compras-publicas-sustentables.pdf"
            href={`/${SUSTAINABLE_PURCHASES_FILE}`}
            target="_blank"
          >
            Descargar instructivo
            <DownloadIcon />
          </DownloadLink>

          <Button color="default" onClick={handleCloseMoreInfoDialog}>
            Cerrar
          </Button>
        </DialogButtons>
      </DialogContent>
    </Dialog>
  )
}

export default QuoteStepTwoMoreInfoDialog
